export const getViewedAds = (): number[] => {
  const data = sessionStorage.getItem("viewedAds");
  return data ? JSON.parse(data) : [];
};

export const updateViewedAds = (data: any[]) => {
  const adsSeen = getViewedAds(); // pega os já vistos
  data.forEach((post) => {
    if (post.ads?.id && !adsSeen.includes(post.ads.id)) {
      adsSeen.push(post.ads.id);
    }
  });
  sessionStorage.setItem("viewedAds", JSON.stringify(adsSeen));
};
